const PRODUCTION_API_ROOT = "https://apidb.rohajewellery.com";

const normalizeRootUrl = (url) => url.replace(/\/+$/, "");

const isLocalApiUrl = (url) =>
  /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(?::\d+)?/i.test(url);

export const getApiRootUrl = () => {
  const configuredUrl = process.env.REACT_APP_API_URL;

  // If no URL configured, use production
  if (!configuredUrl) {
    return PRODUCTION_API_ROOT;
  }

  // If it's a local URL, use it as-is (don't switch to production)
  if (isLocalApiUrl(configuredUrl)) {
    return normalizeRootUrl(configuredUrl);
  }

  // Otherwise use the configured URL
  return normalizeRootUrl(configuredUrl.replace(/\/api\/v1\/?$/i, ""));
};

export const getApiV1Url = () => `${getApiRootUrl()}/api/v1`;

